import P from "@/admin/prices/PricesView.module.css";
import { cn } from "@/utils/classNames.ts";
import type { Key, ReactNode } from "react";

export interface FilterItem<T extends Key = string> {
    key: T;
    title: ReactNode;
}

export function CustomRadios<T extends Key>({
    onChange,
    value,
    items,
    disabled,
}: {
    onChange: (value: T) => void;
    value: T;
    items: FilterItem<T>[];
    disabled?: boolean;
}) {
    const radios = items.map((item) => {
        const { key, title } = item;

        return (
            <div key={key} className={cn(P.Radio, key === value && P.isActive)} onClick={() => onChange(key)}>
                {title}
            </div>
        );
    });

    return <div className={cn("flex items-center", disabled && "pointer-events-none opacity-70")}>{radios}</div>;
}
